require("./yplus_site_yplusNewspapper.less")
import {  SimpleLinkRenderer } from "../../../commonComponents/inline/hyperLink";


interface YplusProps {
    yplusNewsPaperLink: string;
    yplusNewsPaperText: string;
    imageSrc: string
}


export class YplusNewspapper extends React.Component<YplusProps> {

  

    render() {
        const { imageSrc, yplusNewsPaperLink, yplusNewsPaperText} = this.props;
        return (
            <div className="yplus-newspapper">
                <div className="newspaper-text">
                        <SimpleLinkRenderer href={yplusNewsPaperLink} >
                           {yplusNewsPaperText}
                        </SimpleLinkRenderer>
                </div>    
                 <div className="newspaper-wrapper">
                        <SimpleLinkRenderer href={yplusNewsPaperLink} >
                            <div className="newspaper-image" ><img src={imageSrc} /></div>
                            <div className="shadow shadow1"></div>
                            <div className="shadow shadow2"></div>
                            <div className="shadow shadow3"></div>
                        </SimpleLinkRenderer>
                </div>
            </div>
        )
    }
}
